// removed by extract-text-webpack-plugin
module.exports = {"ConversationUnreadsIcon":"_3XBscJiYvuMHn0UiHcRR_P","sectionHeader":"KXU0Fz98ojt1cHF3xr7uF","TicketIcon":"_1rOWxhL2IGHR9NDVl0ZEBq","CoworkerIcon":"_1S_tRmMHXlruR8sZ01aWH4","LeftPanelTabs":"_31J4FlZTf1_Qv0r2_Jcqfk","previewTabs":"_2lX_HWpQzLO-tiWBcHcp6w","MessageListWrapper":"HQmM9lFSDcoAQuHg8rZH"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/LeftPanel/index.css
// module id = 1972
// module chunks = 0